import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa";
import solarResources from "./solarResources";
import { toast } from "react-toastify";
import "../../styles/solar-resources.css";

export default function SolarResourceDetail() {
  const { id } = useParams();
  const resource = solarResources.find((r) => r.id === parseInt(id));
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePaystackPayment = () => {
    if (!resource) {
      toast.error("Resource not found.");
      return;
    }
    setShowModal(true); // ✅ open modal instead of prompt
  };

  const handleEmailSubmit = () => {
    if (!email || !email.trim()) {
      toast.info("Please enter a valid email address.");
      return;
    }

    setShowModal(false);
    setLoading(true);

    const handler = window.PaystackPop.setup({
      key: "pk_live_7264851bb6628e9752b2aafb66c35e9064d1efe7",
      email: email.trim(),
      amount: resource.price * 100,
      currency: "NGN",
      ref: "SR-" + Math.floor(Math.random() * 1000000000),
      callback: function (response) {
        toast.success("✅ Payment successful! Preparing your PDF...");

        // Send request to backend to email PDF
        fetch("https://globisun-app.onrender.com/api/send-pdf", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim(),
            pdfName: resource.pdfName,
            message: `Thank you for purchasing "${resource.title}". Please find your attached PDF below.`,
          }),
        })
          .then(async (res) => {
            const data = await res.json();
            console.log("📦 Server response:", data);
            if (data.success) {
              toast.success("🎉 Your PDF has been sent to your email!");
            } else {
              toast.error("⚠️ Payment verified, but email could not be sent.");
            }
          })
          .catch((err) => {
            console.error("❌ Error sending email:", err);
            toast.error("An error occurred while sending your email. Please contact support.");
          })
          .finally(() => setLoading(false));
      },
      onClose: function () {
        setLoading(false);
        toast.info("Payment window closed.");
      },
    });

    handler.openIframe();
  };

  if (!resource) return <p className="error-message">Resource not found.</p>;

  return (
    <div className="solar-detail-container">
      <div className="solar-detail-card">
        <div className="card-header">
          <FaFilePdf className="resource-icon" />
          <h2>{resource.title}</h2>
        </div>

        <p className="description">
          {resource.longDescription || resource.description}
        </p>

        <div className="detail-footer">
          <span className="price-badge">₦{resource.price}</span>
          <button onClick={handlePaystackPayment} className="btn" disabled={loading}>
            {loading ? "Processing..." : "Buy & Receive PDF by Email"}
          </button>
        </div>
      </div>

      {/* ✅ Custom Email Modal */}
      {showModal && (
        <div className="email-modal-overlay">
          <div className="email-modal">
            <h3>Enter Your Email</h3>
            <p>PDF copy will be automatically sent to this email address.</p>
            <input
              type="email"
              placeholder="e.g. yourname@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="email-input"
            />
            <div className="modal-buttons">
              <button className="btn cancel-btn" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button className="btn pay-btn" onClick={handleEmailSubmit}>
                Proceed to Pay
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
